import React from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { create, update, remove } from '~/actions/recipe';
import MultiPickerCount from '~/components/MultiPickerCount';
import RawMaterialPicker from '~/components/RawMaterialPicker';
import ArticlePicker from '~/components/ArticlePicker';
import Title from '~/components/Title';
import styleDialog from '~/style/dialog.scss';
import style from './style.scss';

const MultiPickerRawMaterial = MultiPickerCount(RawMaterialPicker);
const MultiPickerArticle = MultiPickerCount(ArticlePicker);

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = (props.data && props.data.item) ? props.data.item : {
      materials: [],
      articles: [],
      name: ''
    };
  }

  submit() {
    if (this.state.id) {
      const { id, ...rest } = this.state;
      return update(this.props.dispatch, this.context.apiClient, id, rest)
        .then(() => this.context.dialogClose(this.props.dialogId));
    }
    return create(this.props.dispatch, this.context.apiClient, this.state)
      .then(() => this.context.dialogClose(this.props.dialogId));
  }

  remove() {
    remove(this.props.dispatch, this.context.apiClient, this.state.id)
      .then(() => this.context.dialogClose(this.props.dialogId))
      .then(() => this.props.data.onRemove && this.props.data.onRemove());
  }

  renderContent() {
    return (<form onSubmit={e => { e.preventDefault(); this.submit(); }}>
      <Title>Recipe</Title>
      <Input label="Name" required value={this.state.name} onChange={name => this.setState({ name })} />
      <div style={{ overflow: 'auto', maxWidth: '50vw', maxHeight: '50vh' }}>
        <Title>Material</Title>
        <br />
        <MultiPickerRawMaterial
          value={this.state.materials.reduce((s, v) => ({ ...s, [v.id]: v.count }), {})}
          step={1}
          min={0.001}
          precision={3}
          onChange={v => this.setState({
            materials: Object.keys(v).map(k => ({ id: k, count: v[k] }))
          })}
        />
        <br />
        <Title>Produces</Title>
        <br />
        <MultiPickerArticle
          value={this.state.articles.reduce((s, v) => ({ ...s, [v.id]: v.count }), {})}
          onChange={v => this.setState({
            articles: Object.keys(v).map(k => ({ id: k, count: v[k] }))
          })}
        />
        <br />
      </div>
      <div>
        {
          this.state.id && <Button
            label="Remove recipe"
            primary
            style={{ float: 'right' }}
            onClick={() => this.context.dialogPush('message', { content: 'Are you sure?', onConfirm: () => this.remove() })}
          />
        }
        <Button label={this.state.id ? 'Save' : 'Create'} type="submit" primary raised />
      </div>
      {this.state.removed && <div className={style.removed}>REMOVED</div>}
    </form>);
  }

  render() {
    return (<div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
      <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
        <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
        <div className={styleDialog.content}>
          {this.renderContent()}
        </div>
      </div>
    </div>);
  }
}

const mapStateToProps = state => ({
  rawMaterials: state.getIn(['rawMaterial', 'items']).toJS(),
  articles: state.getIn(['articles', 'articles']).toJS(),
});

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/Recipe/index.js